import { Component } from "react";
import Modal from 'react-bootstrap/Modal';
import { Navigate } from "react-router-dom";
import { withRouter } from '../../common/with-router';
import {Card, Form, Button, Row, Col, Table, Dropdown, Alert, Badge} from "react-bootstrap";
import { FaPlus, FaRegEdit, FaSearch, FaTrash, FaEraser, FaArrowUp, FaArrowDown, FaQuestionCircle, FaGripVertical } from "react-icons/fa";
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
import api from "../../services/api";
import { hasPerm, tiposCampos } from '../../common/utils';
import Paginacao from '../../common/pagination';
import AsyncSelect from 'react-select/async';
import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';
import { useEffect, useState } from "react";
import OpcoesCheckboxEditor from "./OpcoesCheckboxEditor";

const StrictModeDroppable = ({ children, ...props }) => {
  const [enabled, setEnabled] = useState(false);
  useEffect(() => {
    const animation = requestAnimationFrame(() => setEnabled(true));
    return () => {
      cancelAnimationFrame(animation);
      setEnabled(false);
    };
  }, []);
  if (!enabled) {
    return null;
  }
  return <Droppable {...props}>{children}</Droppable>;
};

class CamposPersonalizados extends Component {
    constructor(props) {
        super(props);
        this.onChangeBusca = this.onChangeBusca.bind(this);
        this.onClickPagina = this.onClickPagina.bind(this);
        this.buscaRegistro = this.buscaRegistro.bind(this);

        this.state = {
            listRegistros: [],
            error: "",
            busca: "",
            filtro_programa_id: '',
            filtro_programa_nome: '',
            campo_personalizado_id: null,
            page_numb: 1,
            programas_list: [{programa_id: null, programa__nome: '', secao: '', gerar_historico: false}],
            doencas_list: [],
            programas_register: [],
            nome: '',
            slug: '', 
            descricao: '', 
            ordem: '', 
            tipo: '',
            obrigatorio: '', 
            extencoes_permitidas: '', 
            opcoes: '', 
            mascara: '',
            maskBuilderMode: '',
            maskBuilderValues: {
                target: '',
                value: '',
                type: '',
                operator: 'eq',
                context: 'both',
                positionType: 'after',
                lengthType: 'min',
                lengthValue: 0,
                alertMessage: '',
                alertCanView: []
            },
            showDicionarioCampos: false,
        };
    }
    componentDidMount(){
        this.consultaCamposPersonalizados(this.state.busca, this.state.page_numb)
    }

    consultaCamposPersonalizados(busca, page_numb=1){
        let url=`/pessoas/beneficiarios/campos/?nome=${busca}&page=${page_numb}&order=ordem&order_by=asc`
        if(this.state.filtro_programa_id){
            url += `&programa_id=${this.state.filtro_programa_id}`
        }
        api.get(url)
        .then(response => {
            this.setState({
                loading: false,
                error: "",
                listRegistros: response.data
            });
        })
        .catch(error => {
            let erro_msg = 'Erro ao consultar campos personalizados pacientes, tente novamente.';

            if(error.response.status === 500){
                erro_msg = 'Servidor indisponível no momento';
            }
            else if(error.response.status === 403){
                erro_msg = 'Você não tem permissão para acessar essa área';
            }

            this.setState({
                loading: false,
                error: erro_msg
            });
        });
    }

    splitMascaraTopLevel = (mascara = '') => {
        const tokens = [];
        let atual = '';
        let bracketDepth = 0;

        for (const ch of (mascara || '')) {
            if (ch === '[') bracketDepth += 1;
            if (ch === ']') bracketDepth = Math.max(0, bracketDepth - 1);

            if (ch === '|' && bracketDepth === 0) {
                tokens.push(atual);
                atual = '';
                continue;
            }

            atual += ch;
        }

        if (atual) tokens.push(atual);
        return tokens;
    };

    normalizeMascara = (mascara = '') => {
        if (!mascara || typeof mascara !== 'string') return '';

        let normalized = mascara
            .trim()
            .replace(/\s*\|\s*/g, '|')
            .replace(/\|{2,}/g, '|')
            .replace(/^\||\|$/g, '');

        normalized = normalized.replace(
            /(show-on(?:-any|-all)?\[[^\]]*?)(?=\|(information-field|policy-accept|position-bottom|divisor|context=(?:new|edit|both)|minLength=\d+|maxLength=\d+|position-(?:after|before)=))/gi,
            '$1]'
        );

        const tokens = this.splitMascaraTopLevel(normalized)
            .map(token => token.trim())
            .filter(Boolean)
            .map((token) => {
                if (/^show-on(?:-any|-all)?\[/i.test(token) && !token.includes(']')) {
                    return `${token}]`;
                }
                return token;
            });

        return tokens.join('|');
    };

    salvarCampo = async (e, tipo_update) => {
        if (e) {
            e.preventDefault();
        }

        this.setState({
            loading: true,
        });

        // Verifica se é uma atualização de campo e não uma atualização de ordem
        if (tipo_update !== "ordem" && this.state.campo_personalizado_id) {
            // Cria uma promessa para confirmar a alteração
            const confirmarAlteracao = async () => {
                const MySwal = withReactContent(Swal);
                const result = await MySwal.fire({
                    title: 'Confirmação',
                    html: <p>Deseja realmente alterar este campo personalizado?</p>,
                    icon: 'question',
                    showCancelButton: true,
                    confirmButtonText: 'Sim, alterar',
                    cancelButtonText: 'Cancelar',
                    showCloseButton: true,
                });
                
                // Se o usuário confirmar, retorna true, caso contrário, false
                return result.isConfirmed;
            };
            
            // Verifica se o usuário confirmou a alteração
            const confirmado = await confirmarAlteracao();
            if (!confirmado) {
                this.setState({ loading: false });
                return; // Interrompe a execução se o usuário cancelar
            }
        }
        let payload = {};
        //vererifica se é edição ou adição
        const url = (this.state.campo_personalizado_id) ? '/pessoas/beneficiarios/campos/'+this.state.campo_personalizado_id+'/' : '/pessoas/beneficiarios/campos/'
        const metodo = (this.state.campo_personalizado_id) ? 'put' : 'post'
        if(tipo_update == "ordem") {
            payload = {
                tipo_update: tipo_update,
                campos_ordem: this.state.listRegistros.results.map((item, index) => ({
                    campo_personalizado_id: item.id,
                    programa_id: this.state.filtro_programa_id,
                    ordem: index + 1
                }))
            };
        } else {
            const mascaraNormalizada = this.normalizeMascara(this.state.mascara || '');
            const mascaraTokens = this.splitMascaraTopLevel(mascaraNormalizada)
                .map(token => token.trim())
                .filter(Boolean);

            const isInformacao = this.state.tipo === 'informacao';
            const tipoPayload = isInformacao ? 'texto' : this.state.tipo;

            if (isInformacao && !mascaraTokens.includes('information-field')) {
                mascaraTokens.push('information-field');
            }

            const mascaraPayload = mascaraTokens.join('|');

            payload = {
                nome: this.state.nome,
                slug: this.state.slug,
                tipo: tipoPayload,
                status: true,   
                programas_register: this.state.programas_list.map(programa => ({
                    programa_id: programa.programa_id,
                    programa__nome: programa.programa__nome,
                    secao: programa.secao,
                    gerar_historico: programa.gerar_historico,
                })),
                doencas_register: this.state.doencas_list.map(doenca => ({
                    doenca_id: doenca.doenca_id,
                }))

            };
    
            if(this.state.descricao) {
                payload['descricao'] = this.state.descricao;
            }
                if(mascaraPayload) {
                    payload['mascara'] = mascaraPayload;
            }
    
            if(this.state.ordem) {
                payload['ordem'] = this.state.ordem;
            }
            if(this.state.opcoes) {
                payload['opcoes'] = this.state.opcoes;
              }
            if(this.state.obrigatorio) {
                payload['obrigatorio'] = this.state.obrigatorio;
              }
            if(this.state.extencoes_permitidas) {
                payload['extencoes_permitidas'] = this.state.extencoes_permitidas;
              }
        }
        
        //envia para api
        api({
            method: metodo,
            url: url,
            data: payload,
        })
        .then(response => {
            const MySwal = withReactContent(Swal)
            const textSwal = (this.state.campo_personalizado_id) ? 'Campo personalizado atualizado com sucesso' : 'Campo personalizado cadastrado com sucesso';

            if (tipo_update != "ordem") {
                MySwal.fire({
                    title: 'Sucesso!',
                    html: <p>{textSwal}</p>,
                    icon: 'success',
                    showCloseButton: true,
                })
            }

            this.setState({
                loading: false,
                showModalCampo: false
            })
            
            this.consultaCamposPersonalizados(this.state.busca, this.state.page_numb);
        })
        .catch(error => {
            let erro_msg = 'Erro ao cadastrar campo personalizado paciente, verifique os campos e tente novamente';
        
            if (error.response && error.response.status === 500) {
                erro_msg = 'Servidor indisponível no momento';
            } 
            else if (error.response && error.response.status === 400) {
                const campos = error.response.data;
        
                if (typeof campos === 'object' && campos !== null) {
                    erro_msg = Object.entries(campos)
                        .map(([campo, mensagens]) => mensagens.join('<br/>'))
                        .join('<br/>');
                } else {
                    erro_msg = String(campos);
                }
            }
        
            if (tipo_update !== "ordem") {
                const MySwal = withReactContent(Swal);
                MySwal.fire({
                    icon: 'error',
                    showCloseButton: true,
                    title: 'Erro!',
                    html: erro_msg, 
                });
            }
        
            this.setState({
                loading: false,
            });
        });
    }

    onDragEnd = (result) => {
        if (!result.destination) {
            return;
        }

        const sourceIndex = result.source.index;
        const destinationIndex = result.destination.index;

        if (sourceIndex === destinationIndex) {
            return;
        }

        const novasOrdens = Array.from(this.state.listRegistros.results);
        const [removed] = novasOrdens.splice(sourceIndex, 1);
        novasOrdens.splice(destinationIndex, 0, removed);

        novasOrdens.forEach((item, index) => {
            item.ordem = index + 1;
        });

        const draggedId = result.draggableId.split('-')[1];

        this.setState({ 
            campo_personalizado_id: draggedId,
            listRegistros: { ...this.state.listRegistros, results: novasOrdens } 
        }, () => {
            this.salvarCampo(null, "ordem");
        });
    };

    moverOrdem = (index, direcao, campo_personalizado_id) => {
        this.setState({
            campo_personalizado_id: campo_personalizado_id
        });

        let novasOrdens = [...this.state.listRegistros.results];

        let campoMovido = { ...novasOrdens[index] };
    
        if (direcao === 'up' && index > 0) {
            // Troca a etapa atual com a anterior
            novasOrdens[index] = novasOrdens[index - 1];
            novasOrdens[index - 1] = campoMovido;
            // Atualiza a ordem (index baseado em 1 para a ordem)
            novasOrdens[index].ordem = index + 1;
            novasOrdens[index - 1].ordem = index;
        } else if (direcao === 'down' && index < novasOrdens.length - 1) {
            // Troca a etapa atual com a seguinte
            novasOrdens[index] = novasOrdens[index + 1];
            novasOrdens[index + 1] = campoMovido;
            // Atualiza a ordem
            novasOrdens[index].ordem = index + 1;
            novasOrdens[index + 1].ordem = index + 2;
        }
    
        // Atualiza o estado
        this.setState({ listRegistros: { ...this.state.listRegistros, results: novasOrdens } }, () => {
            //Salva a ordem dos campos
            this.salvarCampo(null,"ordem");
        });
    };

    splitMaskRules = (mask) => {
        if (!mask) return [];
        return mask.split(/\|(?![^[]*\])/).map(s => s.trim()).filter(Boolean);
    };

    renderRows = () => {
        if ('results' in this.state.listRegistros && this.state.listRegistros.results.length > 0) {
            return this.state.listRegistros.results.map((item, index) => (
                <Draggable 
                    key={`${item.id || item.slug}-${index}`}
                    draggableId={`campo-${item.id || item.slug}`} 
                    index={index}
                    isDragDisabled={!this.state.filtro_programa_id}
                >
                    {(provided, snapshot) => {
                        const style = {
                            ...provided.draggableProps.style,
                            backgroundColor: snapshot.isDragging ? '#e9ecef' : 'white',
                            display: snapshot.isDragging ? 'table' : undefined, 
                            width: snapshot.isDragging ? '100%' : undefined,
                            boxShadow: snapshot.isDragging ? '0 5px 10px rgba(0,0,0,0.15)' : 'none',
                            border: snapshot.isDragging ? '1px solid #dee2e6' : 'none',
                            zIndex: snapshot.isDragging ? 9999 : 'auto',
                        };

                        return (
                            <tr 
                                ref={provided.innerRef}
                                {...provided.draggableProps}
                                style={style}
                            >
                                <td>
                                    <div className="d-flex align-items-center">
                                        {this.state.filtro_programa_id && (
                                            <span 
                                                {...provided.dragHandleProps} 
                                                style={{ cursor: 'grab', marginRight: '10px', color: '#6c757d', fontSize: '1.1em' }}
                                                title="Clique e arraste para reordenar"
                                            >
                                                <FaGripVertical />
                                            </span>
                                        )}
                                        {item.id}
                                    </div>
                                </td>
                                <td>{item.nome}</td>
                                <td>{item.slug}</td>
                                <td>{item.tipo}</td>
                                <td>
                                    <div className="d-flex align-items-center gap-2">
                                        <span style={{ minWidth: '20px', fontWeight: 'bold' }}>
                                            {item.programas_list.find(programa => programa.programa_id == this.state.filtro_programa_id)?.ordem || "-"}
                                        </span>
                                        
                                        {this.state.filtro_programa_id && item.id && (
                                            <div className="d-flex flex-column text-muted opacity-50">
                                                {index > 0 && (
                                                    <FaArrowUp style={{ fontSize: '0.7rem' }} />
                                                )}
                                                {index < this.state.listRegistros.results.length - 1 && (
                                                    <FaArrowDown style={{ fontSize: '0.7rem' }} />
                                                )}
                                            </div>
                                        )}
                                    </div>
                                </td>
                                <td className="text-end">
                                    <div className="d-flex justify-content-end gap-2">
                                        <Button 
                                            variant="outline-secondary" 
                                            className="btn-sm" 
                                            onClick={() => this.handleOpenModalCampo(item)}
                                            title="Editar"
                                        >
                                            <FaRegEdit />
                                        </Button> 
                                        <Button 
                                            variant="outline-danger" 
                                            className="btn-sm" 
                                            onClick={() => this.handleDelete(item.id)}
                                            title="Excluir"
                                        >
                                            <FaTrash />
                                        </Button>
                                    </div>   
                                </td>
                            </tr>
                        );
                    }}
                </Draggable>
            ));
        }
    
        return (
            <tr>
                <td colSpan={6}>
                    {this.state.filtro_programa_id
                        ? 'Nenhum campo personalizado paciente encontrado para o programa selecionado'
                        : 'Nenhum campo personalizado paciente encontrado'}
                </td>
            </tr>
        );
    };
    
    handleDelete = (id) => {
        Swal.fire({
            title: 'Tem certeza?',
            text: "Essa ação não poderá ser desfeita!",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#d33',
            cancelButtonColor: '#3085d6',
            confirmButtonText: 'Sim, excluir!',
            cancelButtonText: 'Cancelar'
        }).then((result) => {
            if (result.isConfirmed) {
                api.delete(`/pessoas/beneficiarios/campos/${id}/`)
                .then(response => {
                    Swal.fire(
                        'Excluído!',
                        'O campo personalizado paciente foi excluído com sucesso.',
                        'success'
                    );
                    this.consultaCamposPersonalizados(this.state.busca, this.state.page_numb);
                })
                .catch(error => {
                    Swal.fire(
                        'Erro!',
                        'Ocorreu um problema ao excluir o campo personalizado paciente.',
                        'error'
                    );
                });
            }
        });
    }

    onChangeBusca(e) {
        this.setState({
            busca: e.target.value
        });
    }

    onClickPagina(num_page) {
        this.setState({
            loading: true,
            page_numb: num_page
        });
        
        this.consultaCamposPersonalizados(this.state.busca, num_page)
    }

    buscaRegistro(e) {
        e.preventDefault();
        // Verifica se o programa foi selecionado
        if (!this.state.filtro_programa_id) {
            Swal.fire({
                icon: 'warning',
                title: 'Atenção!',
                html: '<p>Por favor, selecione um programa para continuar.</p>',
                showCloseButton: true,
            });
            return;
        }

        this.setState({
            loading: true,
        });
        
        this.consultaCamposPersonalizados(this.state.busca)
    }

    handleChangeFiltros = (event, fieldName) => {
        if(fieldName == 'programa_id') {
            this.setState({
                listRegistros: {},
                filtro_programa_id: event.value, 
                filtro_programa_nome: event.label
            }, () => {
                this.consultaCamposPersonalizados(this.state.busca, 1);
            });
        }
    };

    limpaFiltro = () => {
        this.setState({
            busca: '',
            filtro_programa_id: null
        }, () => {
            this.consultaCamposPersonalizados(this.state.busca, 1);
        })  
    }

    async carregarCampoPersonalizado(id) {
        try {
            const response = await api.get(`/pessoas/beneficiarios/campos/${id}/`);
            return response.data;
        } catch (error) {
            console.error('Erro ao carregar campo completo:', error);
            return null;
        }
    }

    handleOpenModalCampo = async (item) => {

        if(item && item.id) {
            const campoCompleto = await this.carregarCampoPersonalizado(item.id);

            if (!campoCompleto) {
                Swal.fire('Erro', 'Não foi possível carregar os dados do campo.', 'error');
                return;
            }

            this.setState({
                showModalCampo: true,
                campo_personalizado_id: campoCompleto.id,
                nome: campoCompleto.nome,
                slug: campoCompleto.slug,
                descricao: campoCompleto.descricao,
                ordem: campoCompleto.ordem,
                tipo: (campoCompleto.tipo === 'texto' && (campoCompleto.mascara || '').includes('information-field')) ? 'informacao' : campoCompleto.tipo,
                obrigatorio: campoCompleto.obrigatorio,
                extencoes_permitidas: campoCompleto.extencoes_permitidas,
                opcoes: campoCompleto.opcoes,
                mascara: campoCompleto.mascara,
                programas_list: campoCompleto.programas_list || [],
                doencas_list: campoCompleto.doencas_list || []
            });
        } else {
            this.setState({
                showModalCampo: true,
                campo_personalizado_id: '',
                nome: '',
                slug: '',
                descricao: '',
                ordem: '',
                tipo: '',
                obrigatorio: '',
                extencoes_permitidas: '',
                opcoes: '',
                mascara: '',
                programas_list: [],
                doencas_list: []
            });
        }

        
    }

    handleCloseModalCampo = () => {
        this.setState({
            showModalCampo: false
        });
    }

    carregarProgramas = async (inputValue, index, tipo = 'principal') => {
        if(tipo != 'principal') {
            if(!this.state.programas_list[index].focusPrograma) {
                return [];
            }
        } else {
            if(!this.state.focusPrograma) {
                return [];
            }
        }

        try {
            const response = await api.get(`/programas/?nome=${inputValue}`);
            const opcoes = response.data.results.map(programa => ({
                value: programa.id,
                label: programa.nome
            }));
            return opcoes;
        } catch (error) {
            console.error('Erro ao carregar programas:', error);
            return [];
        }
    };

    adicionarPrograma() {
        this.setState(prevState => ({
            programas_list: [...prevState.programas_list, { programa_id: null, programa__nome: '', secao: '', gerar_historico: false }],
        }));
    }

    removerPrograma(index) {
        this.setState(prevState => ({
            programas_list: prevState.programas_list.filter((_, i) => i !== index),
        }));
    }

    carregarDoencas = async (inputValue, index) => {
        try {
            const response = await api.get(`/doencas/?nome=${inputValue}`);
            const opcoes = response.data.results.map(doenca => ({
                value: doenca.id,
                label: doenca.nome
            }));
            return opcoes;
        } catch (error) {
            console.error('Erro ao carregar doenças:', error);
            return [];
        }
    };

    adicionarDoenca() {
        this.setState(prevState => ({
            doencas_list: [...prevState.doencas_list, { doenca_id: null, doenca__nome: ''}],
        }));
    }

    removerDoenca(index) {
        this.setState(prevState => ({
            doencas_list: prevState.doencas_list.filter((_, i) => i !== index),
        }));
    }

    handleChange = (event, fieldName) => {
        if (fieldName === 'programa_id') {
            const { value, label } = event;
            this.setState({
                [fieldName]: value,
                programa__nome: label,
            });
        } else {
            const { name, value } = event.target;
            const newState = { [name]: value };
    
            //SLUG automatico
            if (name === 'nome') {
                newState.slug = this.gerarSlug(value);
            }
    
            this.setState(newState);
        }
    };

    handleChangePrograma(index, selectedOption) {
        this.setState(prevState => {
            const programas_list = [...prevState.programas_list];
            programas_list[index] = {
                ...programas_list[index],
                programa_id: selectedOption.value,
                programa__nome: selectedOption.label,
            };
            return { programas_list };
        });
    }

    handleSecaoChange(index, event) {
        const { value } = event.target;
        this.setState(prevState => {
            const programas_list = [...prevState.programas_list];
            programas_list[index].secao = value;
            return { programas_list };
        });
    }

    toggleGerarHistorico = (index) => {
        const programas = [...this.state.programas_list];
        programas[index] = {
            ...programas[index],
            gerar_historico: !programas[index].gerar_historico,
        };
        this.setState({ programas_list: programas });
    };

    handleChangeDoenca(index, selectedOption) {
        this.setState(prevState => {
            const doencas_list = [...prevState.doencas_list];
            doencas_list[index] = {
                ...doencas_list[index],
                doenca_id: selectedOption.value,
                doenca__nome: selectedOption.label,
            };
            return { doencas_list };
        });
    }

    gerarSlug = (nome) => {
        return nome
            .toLowerCase()
            .normalize('NFD') // Remove acentos
            .replace(/[\u0300-\u036f]/g, '')
            .replace(/[^a-z0-9-]/g, '-') // Substitui caracteres inválidos
            .replace(/--+/g, '-')        // Remove hífens duplicados
            .replace(/^-|-$| /g, '');    // Remove hífen do início/fim e espaços
    };

    handleBuilderChange = (field, value) => {
        this.setState(prevState => ({
            maskBuilderValues: {
                ...prevState.maskBuilderValues,
                [field]: value
            }
        }));
    };

    addMaskRule = () => {
        const { maskBuilderMode, maskBuilderValues } = this.state;
        let newRule = '';

        if (maskBuilderMode === 'context') {
            newRule = `context=${maskBuilderValues.context}`;
        } else if (maskBuilderMode === 'position') {
            if (!maskBuilderValues.target) return;
            newRule = `position-${maskBuilderValues.positionType}=${maskBuilderValues.target}`;
        } else if (maskBuilderMode === 'length') {
            if (!maskBuilderValues.lengthValue) return;
            newRule = `${maskBuilderValues.lengthType}-length=${maskBuilderValues.lengthValue}`;
        } else if (maskBuilderMode === 'show-on') {
            if (!maskBuilderValues.target || !maskBuilderValues.value) return;
            // show-on[campo_paciente=tipo_cuidador|campo_valor=outro]
            const fieldType = maskBuilderValues.type === 'extra' ? 'campo_extra' : 'campo_paciente';
            newRule = `show-on[${fieldType}=${maskBuilderValues.target}|campo_valor=${maskBuilderValues.value}]`;
        } else if (maskBuilderMode === 'calc') {
            const field = maskBuilderValues.calcField || 'data_nascimento';
            const op = maskBuilderValues.calcOp || 'gt';
            const val = maskBuilderValues.calcValue;
            if (!val) return;
            // show-on[campo_paciente=data_nascimento|calc=age-gt-18]
            newRule = `show-on[campo_paciente=${field}|calc=age-${op}-${val}]`;
        } else if (maskBuilderMode === 'layout') {
             if (!maskBuilderValues.layoutType) return;
             newRule = maskBuilderValues.layoutType;
        } else if (maskBuilderMode === 'alert') {
             if (!maskBuilderValues.alertMessage) return;
             const canViewList = maskBuilderValues.alertCanView || [];
             let canViewStr = '';
             if (canViewList.length === 1) {
                 canViewStr = `|can_view=${canViewList[0]}`;
             } else if (canViewList.length > 1) {
                 canViewStr = `|can_view=[${canViewList.join(',')}]`;
             }
             // Wrap in [] to visually group alert + can_view as a single directive
             newRule = `[valor_campo=null.then(mensagemalerta=${maskBuilderValues.alertMessage})${canViewStr}]`;
        }

        if (newRule) {
            this.setState(prevState => {
                const currentMask = prevState.mascara ? prevState.mascara.trim() : '';
                // Se já tiver conteúdo e não terminar com |, adiciona |

                // Avoid duplicates for simple flags
                if ((maskBuilderMode === 'layout') && currentMask.includes(newRule)) {
                    return null;
                }

                const separator = (currentMask && !currentMask.endsWith('|')) ? '|' : '';
                return {
                    mascara: currentMask + separator + newRule,
                    // Reset fields after add
                    maskBuilderValues: {
                        target: '',
                        value: '',
                        type: 'patient',
                        operator: 'eq',
                        context: 'both',
                        positionType: 'after',
                        lengthType: 'min',
                        lengthValue: 0,
                        calcField: 'data_nascimento',
                        calcOp: 'gt',
                        calcValue: '',
                        alertMessage: '',
                        alertCanView: []
                    },
                    maskBuilderMode: ''
                };
            });
        }
    };

    handleDeleteRule = (index) => {
        this.setState(prevState => {
            const rules = this.splitMaskRules(prevState.mascara || '');
            rules.splice(index, 1);
            return { mascara: rules.join('|') };
        });
    };

    handleEditRule = (index) => {
        const { mascara } = this.state;
        const rules = this.splitMaskRules(mascara || '');
        const ruleToEdit = rules[index];

        if (!ruleToEdit) return;

        // Parse logic to populate builder
        let newMode = '';
        let newValues = { 
            target: '', value: '', type: 'patient', operator: 'eq', context: 'both',
            positionType: 'after', lengthType: 'min', lengthValue: 0,
            calcField: 'data_nascimento', calcOp: 'gt', calcValue: ''
        };

        if (ruleToEdit.startsWith('context=')) {
            newMode = 'context';
            newValues.context = ruleToEdit.split('=')[1];
        } else if (ruleToEdit.includes('length=')) {
            newMode = 'length';
            const [typePart, val] = ruleToEdit.split('=');
            newValues.lengthType = typePart.replace('-length', '');
            newValues.lengthValue = val;
        } else if (ruleToEdit.includes('position-')) {
            newMode = 'position';
            const [key, val] = ruleToEdit.split('=');
            newValues.positionType = key.replace('position-', '');
            newValues.positionType = key.replace('position-', '');
            newValues.target = val;
            
            // Tenta adivinhar a origem: se tá no dicionário é fixo (patient), senão personalizado (extra)
            newValues.type = dicionarioCampos.some(c => c.slug === val) ? 'patient' : 'extra';
        } else if (ruleToEdit === 'divisor' || ruleToEdit === 'policy-accept' || ruleToEdit === 'position-bottom') {
            newMode = 'layout';
            newValues.layoutType = ruleToEdit;
        } else if (ruleToEdit.startsWith('[valor_campo=null.then(mensagemalerta=') || ruleToEdit.startsWith('valor_campo=null.then(mensagemalerta=')) {
            newMode = 'alert';
            const matchMsg = ruleToEdit.match(/mensagemalerta=(.+?)\)/);
            if (matchMsg) newValues.alertMessage = matchMsg[1];
            // Parse can_view (single or list)
            const matchCv = ruleToEdit.match(/can_view=\[([^\]]+)\]|can_view=(\w+)/);
            if (matchCv) {
                const str = matchCv[1] || matchCv[2];
                newValues.alertCanView = str.split(',').map(s => s.trim());
            } else {
                newValues.alertCanView = [];
            }
        } else if (ruleToEdit.includes('show-on[')) {
            // Check for calc
            if (ruleToEdit.includes('calc=')) {
                newMode = 'calc';
                // show-on[campo_paciente=data|calc=age-gt-18]
                const match = ruleToEdit.match(/campo_paciente=([^|]+)\|calc=age-([a-z]+)-(\d+)/);
                if (match) {
                    newValues.calcField = match[1];
                    newValues.calcOp = match[2];
                    newValues.calcValue = match[3];
                }
            } else {
                newMode = 'show-on';
                // show-on[campo_paciente=X|campo_valor=Y]
                const body = ruleToEdit.match(/show-on\[(.*?)\]/)[1];
                const parts = body.split('|');
                const typePart = parts.find(p => p.startsWith('campo_paciente=') || p.startsWith('campo_extra='));
                const valPart = parts.find(p => p.startsWith('campo_valor='));

                if (typePart && valPart) {
                    newValues.type = typePart.startsWith('campo_extra') ? 'extra' : 'patient';
                    newValues.target = typePart.split('=')[1];
                    newValues.value = valPart.split('=')[1];
                }
            }
        }

        // Remove rule from list and set builder state
        this.handleDeleteRule(index);
        this.setState({
            maskBuilderMode: newMode,
            maskBuilderValues: newValues
        });
    };

    renderMaskBuilder = () => {
        const { maskBuilderMode, maskBuilderValues } = this.state;

        const handleSelectCampoFixo = (slug) => {
            if (maskBuilderMode === 'calc') {
                this.handleBuilderChange('calcField', slug);
            } else {
                this.handleBuilderChange('target', slug);
            }
            this.setState({ showDicionarioCampos: false });
        };
        
        const dicionarioCampos = [
            { slug: "programa_id", nome: "Programa Vinculado" },
            { slug: "doenca_id", nome: "Doença e Condição Clínica do Paciente" },
            { slug: "nome", nome: "Nome do Beneficiário" },
            { slug: "cpf", nome: "CPF" },
            { slug: "data_nascimento", nome: "Data de Nascimento" },
            { slug: "sexo", nome: "Sexo/Gênero" },
            { slug: "email", nome: "E-mail" },
            { slug: "telefone", nome: "Celular com WhatsApp" },
            { slug: "celular", nome: "Telefone Celular" },
            { slug: "cep", nome: "CEP" },
            { slug: "endereco", nome: "Endereço" },
            { slug: "numero", nome: "Número" },
            { slug: "complemento", nome: "Complemento" },
            { slug: "bairro", nome: "Bairro" },
            { slug: "cidade", nome: "Cidade" },
            { slug: "uf", nome: "Estado" },
            { slug: "vinculo_cuidador", nome: "Possui Representante Legal ou Cuidador? (true/false)" },
            { slug: "tipo_cuidador", nome: "Tipo do Cuidador/Representante Legal" },
            { slug: "cuidador_documento_file", nome: "Anexar documento de vínculo legal" },
            { slug: "cuidador_nome", nome: "Nome do Cuidador" },
            { slug: "cuidador_cpf", nome: "CPF do Cuidador" },
            { slug: "cuidador_data_nascimento", nome: "Data de Nascimento do Cuidador" },
            { slug: "cuidador_telefone", nome: "Telefone do Cuidador" },
            { slug: "cuidador_email", nome: "E-mail do Cuidador" },
            { slug: "cuidador_rg", nome: "RG do Cuidador" },
            { slug: "cuidador_rg_orgao", nome: "Órgão Expedidor - UF (Cuidador)" },
            { slug: "cuidador_mesmo_endereco", nome: "Cuidador tem o mesmo endereço? (true/false)" },
            { slug: "cuidador_cep", nome: "CEP do Cuidador" },
            { slug: "cuidador_endereco", nome: "Endereço do Cuidador" },
            { slug: "cuidador_numero", nome: "Número do Cuidador" },
            { slug: "cuidador_complemento", nome: "Complemento do Cuidador" },
            { slug: "cuidador_bairro", nome: "Bairro do Cuidador" },
            { slug: "cuidador_cidade", nome: "Cidade do Cuidador" },
            { slug: "cuidador_uf", nome: "Estado do Cuidador" },
            { slug: "estado_civil", nome: "Estado civil" },
            { slug: "peso", nome: "Peso (kg)" },
            { slug: "altura", nome: "Altura (cm)" },
            { slug: "nome_mae", nome: "Nome da mãe do paciente" },
            { slug: "rg", nome: "Inscrição RG" },
            { slug: "rg_orgao", nome: "Órgão expedidor - UF" },
            { slug: "cns", nome: "Cartão Nacional de Saúde" },
            { slug: "optin_whatsapp", nome: "Deseja receber comunicações através de Aplicativo de Mensagens? (true/false)" },
            { slug: "optin_email", nome: "Deseja receber comunicações através de e-mail? (true/false)" },
            { slug: "optin_sms", nome: "Deseja receber comunicações através de SMS? (true/false)" },
            { slug: "optin_telefone", nome: "Deseja receber ligações telefônicas? (true/false)" },
            { slug: "senha", nome: "Senha de acesso" }
        ];

        return (
            <Card className="mb-3 bg-light border-0">
                <Card.Body className="p-3">
                    <div className="d-flex justify-content-between align-items-center mb-3">
                        <h6 className="card-title mb-0 d-flex align-items-center">
                            <FaRegEdit className="me-2" /> 
                            Gerador de Regras (No-Code)
                        </h6>
                        {((maskBuilderMode === 'show-on' && maskBuilderValues.type === 'patient') || 
                          (maskBuilderMode === 'calc') || 
                          (maskBuilderMode === 'position' && maskBuilderValues.type === 'patient')) && (
                            <Button 
                                variant="outline-primary" 
                                size="sm"
                                onClick={() => this.setState({showDicionarioCampos: true})}
                            >
                                <span className="me-1">👁️</span> Dicionário de Campos Fixos
                            </Button>
                        )}
                    </div>

                    {/* Modal Dicionário de Campos */}
                    <Modal 
                        show={this.state.showDicionarioCampos} 
                        onHide={() => this.setState({showDicionarioCampos: false})}
                        size="lg"
                    >
                        <Modal.Header closeButton>
                            <Modal.Title>Dicionário de Campos Fixos</Modal.Title>
                        </Modal.Header>
                        <Modal.Body style={{maxHeight: '70vh', overflowY: 'auto'}}>
                            <Alert variant="info" className="mb-3">
                                Utilize os <b>Slugs</b> abaixo para referenciar campos fixos do sistema nas diretivas de posicionamento ou visibilidade (usando origem "Cadastro Fixo").
                            </Alert>
                            <Table striped bordered hover size="sm">
                                <thead>
                                    <tr>
                                        <th>Nome do Campo (Referência)</th>
                                        <th>Slug (Identificador)</th>
                                        <th style={{width: '120px'}} className="text-center">Ação</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {dicionarioCampos.map((campo, idx) => (
                                        <tr key={idx} className="align-middle">
                                            <td>{campo.nome}</td>
                                            <td><code className="bg-light p-1 rounded user-select-all">{campo.slug}</code></td>
                                            <td className="text-center">
                                                <Button 
                                                    variant="outline-primary" 
                                                    size="sm" 
                                                    className="py-0 px-2"
                                                    style={{ fontSize: '0.8rem' }}
                                                    onClick={() => handleSelectCampoFixo(campo.slug)}
                                                    title="Usar este identificador"
                                                >
                                                    Usar Slug
                                                </Button>
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </Table>
                        </Modal.Body>
                        <Modal.Footer>
                            <Button variant="secondary" onClick={() => this.setState({showDicionarioCampos: false})}>
                                Fechar
                            </Button>
                        </Modal.Footer>
                    </Modal>
                    
                    <Row className="g-3 align-items-end">
                        <Col sm={3}>
                            <Form.Label>Tipo de Regra</Form.Label>
                            <Form.Select 
                                value={maskBuilderMode}
                                onChange={(e) => this.setState({ maskBuilderMode: e.target.value })}
                                size="sm"
                            >
                                <option value="">Selecione...</option>
                                <option value="show-on">Visibilidade (Show On)</option>
                                <option value="calc">Cálculo (Idade)</option>
                                <option value="context">Contexto (New/Edit)</option>
                                 <option value="position">Posicionamento (Antes/Depois)</option>
                                <option value="length">Validação de Tamanho (Lenght??)</option>
                                <option value="layout">Layout e Comportamento</option>
                                <option value="alert">Alerta Dinâmico (Persistent)</option>
                            </Form.Select>
                        </Col>

                        {maskBuilderMode === 'context' && (
                            <Col sm={3}>
                                <Form.Label>Contexto</Form.Label>
                                <Form.Select 
                                    value={maskBuilderValues.context}
                                    onChange={(e) => this.handleBuilderChange('context', e.target.value)}
                                    size="sm"
                                >
                                    <option value="both">Ambos (Padrão)</option>
                                    <option value="new">Cadastro (New)</option>
                                    <option value="edit">Edição (Edit)</option>
                                </Form.Select>
                            </Col>
                        )}

                        {maskBuilderMode === 'position' && (
                            <>
                                <Col sm={2}>
                                    <Form.Label>Origem</Form.Label>
                                    <Form.Select
                                        value={maskBuilderValues.type || 'patient'}
                                        onChange={(e) => this.handleBuilderChange('type', e.target.value)}
                                        size="sm"
                                    >
                                        <option value="patient">Cadastro Fixo</option>
                                        <option value="extra">Personalizado</option>
                                    </Form.Select>
                                </Col>
                                <Col sm={3}>
                                    <Form.Label>Relativo a</Form.Label>
                                    <Form.Select
                                        value={maskBuilderValues.positionType}
                                        onChange={(e) => this.handleBuilderChange('positionType', e.target.value)}
                                        size="sm"
                                    >
                                        <option value="after">Depois de (After)</option>
                                        <option value="before">Antes de (Before)</option>
                                    </Form.Select>
                                </Col>
                                <Col sm={3}>
                                    <Form.Label>
                                        Slug do Campo Alvo
                                    </Form.Label>
                                    {maskBuilderValues.type === 'extra' && (
                                        <Form.Text className="text-muted d-block mb-1 mt-0" style={{ fontSize: '0.70rem', lineHeight: '1' }}>
                                            Copie o Slug do campo personalizado desejado na lista principal.
                                        </Form.Text>
                                    )}
                                    <Form.Control
                                        type="text"
                                        placeholder="Ex: nome_campo"
                                        value={maskBuilderValues.target}
                                        onChange={(e) => this.handleBuilderChange('target', e.target.value)}
                                        size="sm"
                                    />
                                </Col>
                            </>
                        )}

                        {maskBuilderMode === 'length' && (
                            <>
                                <Col sm={3}>
                                    <Form.Label>Validação</Form.Label>
                                    <Form.Select
                                        value={maskBuilderValues.lengthType}
                                        onChange={(e) => this.handleBuilderChange('lengthType', e.target.value)}
                                        size="sm"
                                    >
                                        <option value="min">Mínimo (Min Length)</option>
                                        <option value="max">Máximo (Max Length)</option>
                                    </Form.Select>
                                </Col>
                                <Col sm={3}>
                                    <Form.Label>Qtd. Caracteres</Form.Label>
                                    <Form.Control
                                        type="number"
                                        value={maskBuilderValues.lengthValue}
                                        onChange={(e) => this.handleBuilderChange('lengthValue', e.target.value)}
                                        size="sm"
                                    />
                                </Col>
                            </>
                        )}

                        {maskBuilderMode === 'show-on' && (
                            <>
                                <Col sm={2}>
                                    <Form.Label>Origem</Form.Label>
                                    <Form.Select
                                        value={maskBuilderValues.type}
                                        onChange={(e) => this.handleBuilderChange('type', e.target.value)}
                                        size="sm"
                                    >
                                        <option value="patient">Cadastro Fixo</option>
                                        <option value="extra">Personalizado</option>
                                    </Form.Select>
                                </Col>
                                <Col sm={3}>
                                    <Form.Label>Slug do Campo</Form.Label>
                                    {maskBuilderValues.type === 'extra' && (
                                        <Form.Text className="text-muted d-block mb-1 mt-0" style={{ fontSize: '0.70rem', lineHeight: '1' }}>
                                            Copie o Slug do campo personalizado desejado na lista abaixo.
                                        </Form.Text>
                                    )}
                                    <Form.Control
                                        type="text"
                                        placeholder="Ex: tipo_cuidador"
                                        value={maskBuilderValues.target}
                                        onChange={(e) => this.handleBuilderChange('target', e.target.value)}
                                        size="sm"
                                    />
                                </Col>
                                <Col sm={2}>
                                    <Form.Label>Condição</Form.Label>
                                    <Form.Control 
                                        type="text" 
                                        readOnly 
                                        value="Igual a (=)" 
                                        size="sm" 
                                        className="bg-light"
                                    />
                                </Col>
                                <Col sm={2}>
                                    <Form.Label>Valor</Form.Label>
                                    <Form.Control
                                        type="text"
                                        placeholder="Ex: Sim"
                                        value={maskBuilderValues.value}
                                        onChange={(e) => this.handleBuilderChange('value', e.target.value)}
                                        size="sm"
                                    />
                                </Col>
                            </>
                        )}

                        {maskBuilderMode === 'calc' && (
                            <>
                                <Col sm={3}>
                                    <Form.Label>Campo Paciente</Form.Label>
                                    <Form.Control
                                        type="text"
                                        placeholder="Ex: data_nascimento"
                                        value={maskBuilderValues.calcField || 'data_nascimento'}
                                        onChange={(e) => this.handleBuilderChange('calcField', e.target.value)}
                                        size="sm"
                                    />
                                </Col>
                                <Col sm={3}>
                                    <Form.Label>Operador</Form.Label>
                                    <Form.Select
                                        value={maskBuilderValues.calcOp || 'gt'}
                                        onChange={(e) => this.handleBuilderChange('calcOp', e.target.value)}
                                        size="sm"
                                    >
                                        <option value="gt">Maior que {'>'}</option>
                                        <option value="gte">Maior ou Igual {'>='}</option>
                                        <option value="lt">Menor que {'<'}</option>
                                        <option value="lte">Menor ou Igual {'<='}</option>
                                        <option value="eq">Igual a {'='}</option>
                                    </Form.Select>
                                </Col>
                                <Col sm={3}>
                                    <Form.Label>Idade</Form.Label>
                                    <Form.Control
                                        type="number"
                                        placeholder="Ex: 18"
                                        value={maskBuilderValues.calcValue || ''}
                                        onChange={(e) => this.handleBuilderChange('calcValue', e.target.value)}
                                        size="sm"
                                    />
                                </Col>
                            </>
                        )}
                         {maskBuilderMode === 'layout' && (
                            <Col sm={3}>
                                <Form.Label>Diretiva</Form.Label>
                                <Form.Select
                                    value={maskBuilderValues.layoutType}
                                    onChange={(e) => this.handleBuilderChange('layoutType', e.target.value)}
                                    size="sm"
                                >
                                    <option value="">Selecione...</option>
                                    <option value="divisor">Divisor (Linha acima)</option>
                                    <option value="policy-accept">Termo de Aceite/Card</option>
                                    <option value="position-bottom">Posicionar no Rodapé</option>
                                    <option value="pre-allow">Exibir no PRÉ-CADASTRO</option>
                                </Form.Select>
                            </Col>
                        )}
                        
                        {maskBuilderMode === 'alert' && (
                            <>
                                <Col sm={5}>
                                    <Form.Label>Mensagem do Alerta (Exibida se campo estiver vazio)</Form.Label>
                                    <Form.Control
                                        type="text"
                                        placeholder="Ex: Confirmar melhor horário para contato"
                                        value={maskBuilderValues.alertMessage}
                                        onChange={(e) => this.handleBuilderChange('alertMessage', e.target.value)}
                                        size="sm"
                                    />
                                </Col>
                                <Col sm={4}>
                                    <Form.Label>Visível para (can_view) <small className="text-muted">- vazio = todos</small></Form.Label>
                                    <div className="d-flex flex-wrap gap-2">
                                        {['operador', 'gestor', 'medicos', 'multiprofissionais', 'navegador'].map(perfil => (
                                            <Form.Check
                                                key={perfil}
                                                type="checkbox"
                                                id={`canview-${perfil}`}
                                                label={perfil}
                                                checked={(maskBuilderValues.alertCanView || []).includes(perfil)}
                                                onChange={(e) => {
                                                    const current = maskBuilderValues.alertCanView || [];
                                                    const updated = e.target.checked
                                                        ? [...current, perfil]
                                                        : current.filter(p => p !== perfil);
                                                    this.handleBuilderChange('alertCanView', updated);
                                                }}
                                            />
                                        ))}
                                    </div>
                                </Col>
                            </>
                        )}
                        

                        <Col>
                            <Button 
                                variant="primary" 
                                size="sm" 
                                className="w-100"
                                onClick={this.addMaskRule}
                                disabled={!maskBuilderMode}
                            >
                                <FaPlus className="me-1" /> Adicionar
                            </Button>
                        </Col>
                    </Row>

                    {/* Lista de Regras Existentes */}
                    {this.state.mascara && (
                        <div className="mt-3 pt-3 border-top">
                            <h6 className="card-subtitle mb-2 text-muted" style={{fontSize: '0.9rem'}}>Regras Atuais:</h6>
                            <ul className="list-group list-group-flush mb-0" style={{fontSize: '0.85rem'}}>
                                {this.splitMaskRules(this.state.mascara).map((rule, idx) => {
                                   if (!rule.trim()) return null;
                                   return (
                                        <li key={idx} className="list-group-item bg-transparent px-0 py-1 d-flex justify-content-between align-items-center">
                                            <code className="text-dark bg-white border px-1 rounded">{rule.trim()}</code>
                                            <div>
                                                <Button 
                                                    variant="link" 
                                                    className="p-1 text-primary" 
                                                    size="sm"
                                                    title="Editar Regra"
                                                    onClick={() => this.handleEditRule(idx)}
                                                >
                                                    <FaRegEdit />
                                                </Button>
                                                <Button 
                                                    variant="link" 
                                                    className="p-1 text-danger" 
                                                    size="sm"
                                                    title="Remover Regra"
                                                    onClick={() => this.handleDeleteRule(idx)}
                                                >
                                                    <FaTrash />
                                                </Button>
                                            </div>
                                        </li>
                                   );
                                })}
                            </ul>
                        </div>
                    )}
                </Card.Body>
            </Card>
        );
    }

    render() {
        if (!hasPerm('view_campos_personalizados')) {
            return <Navigate to='/sem-permissao' />
        }

        return (
            <div>
                <Row className="align-items-center">
                    <Col sm={6} lg={6}>
                        <h4 className="page-title">Campos Personalizados Pacientes</h4>
                    </Col>
                    <Col sm={6} lg={6} className="text-end">
                        <Button variant="secondary" onClick={() => this.handleOpenModalCampo(null)} className="mb-3" size="sm">
                            <FaPlus /> Adicionar Campo Personalizado Paciente
                        </Button>
                    </Col>
                </Row>
                <Card className="cardDestaque">
                    <Card.Body>
                        <h4>Filtros</h4>
                        <Form method="get" onSubmit={this.buscaRegistro}>
                            <Row>
                                <Col sm={3} xs={12}> 
                                    <Form.Group className="mb-3">
                                        <Form.Label>Programa</Form.Label>
                                        <AsyncSelect
                                            key={this.state.focusPrograma}
                                            loadOptions={(inputValue) => {
                                                return new Promise((resolve) => {
                                                    clearTimeout(this.programaSearchTimeout);
                                                    this.programaSearchTimeout = setTimeout(() => {
                                                        resolve(this.carregarProgramas(inputValue));
                                                    }, 700);
                                                });
                                            }}
                                            onFocus={() => {
                                                this.setState({
                                                    focusPrograma: true
                                                });
                                            }}
                                            autoFocus={this.state.focusPrograma}
                                            openMenuOnFocus={this.state.focusPrograma}
                                            defaultOptions
                                            name="programa_id"
                                            placeholder="Nome do Programa"
                                            noOptionsMessage={() => "Nenhum programa encontrado"}
                                            onChange={e => this.handleChangeFiltros(e, 'programa_id')}
                                            value={this.state.filtro_programa_id ? { value: this.state.filtro_programa_id, label: this.state.filtro_programa_nome } : null}
                                        />
                                    </Form.Group>
                                </Col>
                                {this.state.filtro_programa_id &&
                                    <Col sm={3} xs={12}>
                                        <Form.Group className="mb-3">
                                            <Form.Label>Nome</Form.Label>                                  
                                            <Form.Control
                                                type="text"
                                                name="busca"
                                                value={this.state.busca}
                                                onChange={this.onChangeBusca}
                                                placeholder="Nome do Campo Personalizado"
                                                aria-label="Nome do Campo Personalizado"
                                                aria-describedby="basic-addon2"
                                            />
                                        </Form.Group>
                                    </Col>
                                }
                            </Row>
                            <Button type="submit" variant="secondary" size="sm">
                                <FaSearch /> Filtrar
                            </Button>
                            <Button type="button" size="sm" variant="light" className="ms-2" onClick={() => this.limpaFiltro()}>
                                <FaEraser /> Limpar filtro
                            </Button>
                        </Form>

                        <DragDropContext onDragEnd={this.onDragEnd}>
                            <Table responsive className="custom-table mt-3">
                                <thead>
                                    <tr>
                                        <th>ID</th>
                                        <th>Nome</th>
                                        <th>Slug</th>
                                        <th>Tipo</th>
                                        <th>Ordem</th>
                                        <th></th>
                                    </tr>
                                </thead>
                                <StrictModeDroppable droppableId="lista-campos" isDropDisabled={!this.state.filtro_programa_id}>
                                    {(provided) => (
                                        <tbody
                                            ref={provided.innerRef}
                                            {...provided.droppableProps}
                                        >
                                            {this.state.loading ? (
                                            <tr>
                                                <td colSpan={6}>Carregando...</td>
                                            </tr>
                                            ) : (
                                                this.state.error ? (
                                                    <tr>
                                                        <td colSpan={6}>{this.state.error}</td>
                                                    </tr>
                                                ) : this.renderRows()
                                            )} 
                                            {provided.placeholder}                                                      
                                        </tbody>
                                    )}
                                </StrictModeDroppable>
                            </Table>
                        </DragDropContext>       
                        { 
                            'results' in this.state.listRegistros && this.state.listRegistros.results.length > 0 && 
                            <Paginacao dados={this.state.listRegistros} loading={this.state.loading} page_numb={this.state.page_numb} _onClickPagina={this.onClickPagina} />
                        }                    
                    </Card.Body>                
                </Card>


                <Modal show={this.state.showModalCampo} onHide={this.handleCloseModalCampo} size="xl">
                    <Modal.Header closeButton>
                        <Modal.Title>{((this.state.campo_personalizado_id) ? 'Editar Campo Personalizado Paciente ' + this.state.campo_personalizado_id : 'Adicionar Campo Personalizado Paciente')}</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <Card className="cardDestaque">
                                <Card.Body>                    
                                    <Form onSubmit={this.enviaRegistro}>
                                        <h4>Campos Personalizado Paciente</h4>
                                                <Row>
                                                    <Col sm={6}>
                                                        <Form.Group className="mb-3">
                                                            <Form.Label>Nome <span style={{ color: 'red' }}> *</span></Form.Label>
                                                            <Form.Control 
                                                                type="text" 
                                                                name="nome" 
                                                                value={this.state.nome} 
                                                                onChange={e => this.handleChange(e, 'nome')} 
                                                            />
                                                        </Form.Group>
                                                    </Col>
                                                    <Col sm={6}>
                                                        <Form.Group className="mb-3">
                                                            <Form.Label>Tipo do Campo</Form.Label>
                                                            <Form.Control as="select" name="tipo" value={this.state.tipo} required onChange={e => this.handleChange(e, 'tipo')}>
                                                                <option value="">Tipo</option>
                                                                {Object.entries(tiposCampos).map(([sigla, nome]) => (
                                                                    <option key={sigla} value={sigla}>{nome}</option>
                                                                ))}
                                                            </Form.Control>
                                                        </Form.Group>
                                                    </Col>
                                                    <Col sm={4}>
                                                        <Form.Group className="mb-3">
                                                            <Form.Label>Slug <span style={{ color: 'red' }}> *</span></Form.Label>
                                                            <Form.Control 
                                                                type="text" 
                                                                name="slug"
                                                                value={this.state.slug} 
                                                                onChange={e => this.handleChange(e, 'slug')} 
                                                            />
                                                        </Form.Group>
                                                    </Col>
                                                    <Col sm={2}>
                                                        <Form.Group className="mb-3">
                                                            <Form.Label>Obrigatório?</Form.Label>
                                                            <Form.Select className="form-control" name="obrigatorio" value={this.state.obrigatorio.toString()} onChange={e => this.handleChange(e, 'obrigatorio')}>
                                                                <option value="false">Não</option>
                                                                <option value="true">Sim</option>
                                                            </Form.Select>
                                                        </Form.Group>
                                                    </Col>
                                                    
                                                    {/* Valores Condicionais na mesma linha */}
                                                    {(this.state.tipo == 'arquivo') && (
                                                        <Col sm={6}>
                                                            <Form.Group className="mb-3">
                                                                <Form.Label>Extensões Permitidas</Form.Label>
                                                                <Form.Control 
                                                                    type="text" 
                                                                    name="extencoes_permitidas" 
                                                                    value={this.state.extencoes_permitidas} 
                                                                    onChange={e => this.handleChange(e, 'extensoes_permitidas')} 
                                                                    placeholder=".jpg, .png, .pdf"
                                                                />
                                                            </Form.Group>
                                                        </Col>
                                                    )}
                                                </Row>

                                                {(this.state.tipo == 'selecao' || this.state.tipo == 'checkbox' || this.state.tipo == 'radio') && (
                                                    <Row>
                                                        <Col sm={12}>
                                                            <Form.Group className="mb-3">
                                                                <Form.Label>Valores do Campo</Form.Label>
                                                                <div className="border rounded p-2 bg-white" style={{overflowX: 'auto'}}>
                                                                    <div style={{minWidth: '760px'}}>
                                                                        <OpcoesCheckboxEditor
                                                                            value={this.state.opcoes}
                                                                            onChange={(nextValue) => this.setState({ opcoes: nextValue })}
                                                                        />
                                                                    </div>
                                                                </div>
                                                            </Form.Group>
                                                        </Col>
                                                    </Row>
                                                )}

                                                <hr />
                                                
                                                {/* Seção de Máscara */}
                                                <Row>
                                                    <Col sm={12}>
                                                        <Form.Label className="d-flex justify-content-between align-items-center">
                                                            <span>Máscara / Diretivas Avançadas</span>
                                                            <Button 
                                                                variant="link" 
                                                                className="p-0 text-decoration-none" 
                                                                size="sm"
                                                                onClick={() => this.setState({showMascaraHelp: true})}
                                                            >
                                                                <FaQuestionCircle className="me-1"/> Ver documentação
                                                            </Button>
                                                        </Form.Label>
                                                        
                                                        {this.renderMaskBuilder()}

                                                        <Form.Group className="mb-3">
                                                            <Form.Control 
                                                                as="textarea"
                                                                rows={3} 
                                                                name="mascara" 
                                                                value={this.state.mascara} 
                                                                onChange={e => this.handleChange(e, 'mascara')} 
                                                                placeholder="As regras configuradas aparecerão aqui..."
                                                            />
                                                            <Form.Text className="text-muted" style={{fontSize: '0.9em'}}>
                                                                Você pode usar o gerador acima ou editar manualmente. Separe múltiplas regras com <code>|</code>.
                                                            </Form.Text>
                                                        </Form.Group>
                                                    </Col>
                                                </Row>

                                                {/* Descrição movida para baixo */}
                                                <Row>
                                                    <Col>
                                                        <Form.Group className="mb-3">
                                                            <Form.Label>Descrição</Form.Label>
                                                            <Form.Control 
                                                                as="textarea" 
                                                                name="descricao" 
                                                                value={this.state.descricao} 
                                                                onChange={e => this.handleChange(e, 'descricao')} 
                                                            />
                                                        </Form.Group>
                                                    </Col>
                                                </Row>
                                                <hr />
                                                <h4 className="mt-3">Programas <span style={{ color: 'red' }}> *</span></h4>
                                                {this.state.programas_list.map((programa, index) => (
                                                    <div key={index}>
                                                        <Row>
                                                            <Col sm={4} xs={12}>
                                                                <Form.Group className="mb-3">
                                                                    <Form.Label>Programa</Form.Label>
                                                                    <AsyncSelect
                                                                        key={this.state.programas_list[index].focusPrograma}
                                                                        loadOptions={(inputValue) => {
                                                                            return new Promise((resolve) => {
                                                                                clearTimeout(this.state.programas_list[index].programaSearchTimeout);
                                                                                programa.programaSearchTimeout = setTimeout(() => {
                                                                                    resolve(this.carregarProgramas(inputValue, index, 'programas'));
                                                                                }, 700);
                                                                            });
                                                                        }}
                                                                        onFocus={() => {
                                                                            this.setState({
                                                                                programas_list: this.state.programas_list.map((programa, i) => i === index ? { ...programa, focusPrograma: true } : programa)
                                                                            });
                                                                        }}
                                                                        autoFocus={this.state.programas_list[index].focusPrograma}
                                                                        openMenuOnFocus={this.state.programas_list[index].focusPrograma}
                                                                        defaultOptions
                                                                        name="programa_id"
                                                                        placeholder="Buscar programa..."
                                                                        noOptionsMessage={() => "Nenhum programa encontrado"}
                                                                        onChange={e => this.handleChangePrograma(index, e)}
                                                                        value={programa.programa_id ? { value: programa.programa_id, label: programa.programa__nome } : null}
                                                                    />
                                                                    <Form.Text id="formProgramaHelpBlock" className="text-danger">{this.state.programaHelper}</Form.Text>
                                                                </Form.Group>
                                                            </Col>
                                                            {programa.programa_id && (
                                                                <>
                                                                    <Col sm={4} xs={12}>
                                                                        <Form.Group className="mb-3">
                                                                            <Form.Label>Seção</Form.Label>
                                                                            <Form.Control 
                                                                                type="text" 
                                                                                name="secao" 
                                                                                value={programa.secao} 
                                                                                onChange={e => this.handleSecaoChange(index, e)} 
                                                                            />
                                                                        </Form.Group>
                                                                    </Col>
                                                                </>
                                                            )}
                                                            {programa.programa_id && (
                                                                <Row>
                                                                    <Col >
                                                                        <Form.Group className="mb-3">
                                                                            <Form.Check 
                                                                            type="checkbox" 
                                                                            label="Gerar Histórico" 
                                                                            checked={programa.gerar_historico || false}
                                                                            onChange={() => this.toggleGerarHistorico(index)}
                                                                        />
                                                                        </Form.Group>
                                                                    </Col>
                                                                </Row>
                                                            )}
                                                        </Row>
                                                    </div>
                                                ))}

                                                <Row>
                                                    <Col sm={12} xs={12}>
                                                        <Button variant="secondary" className="btn-sm" onClick={() => this.adicionarPrograma(0)}>Adicionar Programa</Button>
                                                        <Button variant="danger" className="btn-sm" onClick={() => this.removerPrograma(this.state.programas_list.length - 1)}> Remover Programa</Button>
                                                    </Col>
                                                </Row>

                                                <h4 className="mt-3">Doenças Relacionadas (Opcional)</h4>
                                                <p className="text-muted small">
                                                    Selecione uma ou mais doenças para restringir este campo. 
                                                    Se nenhuma doença for selecionada, o campo aparecerá para todas.
                                                </p>
                                                {this.state.doencas_list && this.state.doencas_list.map((doenca, index) => (
                                                    <div key={index}>
                                                        <Row className="align-items-center">
                                                            <Col sm={8} xs={12}>
                                                                <Form.Group className="mb-3">
                                                                    <Form.Label>Doença</Form.Label>
                                                                    <AsyncSelect
                                                                        key={`doenca-${index}`}
                                                                        loadOptions={(inputValue) => this.carregarDoencas(inputValue, index)}
                                                                        defaultOptions
                                                                        name="doenca_id"
                                                                        placeholder="Buscar doença..."
                                                                        noOptionsMessage={() => "Nenhuma doença encontrada"}
                                                                        onChange={e => this.handleChangeDoenca(index, e)}
                                                                        value={doenca.doenca_id ? { value: doenca.doenca_id, label: doenca.doenca__nome } : null}
                                                                    />
                                                                </Form.Group>
                                                            </Col>
                                                        </Row>
                                                    </div>
                                                ))}

                                                <Row>
                                                    <Col sm={12} xs={12}>
                                                        <Button variant="secondary" className="btn-sm" onClick={() => this.adicionarDoenca()}>Adicionar Doença</Button>
                                                        <Button variant="danger" className="btn-sm" onClick={() => this.removerDoenca(this.state.doencas_list.length - 1)}> Remover Doença</Button>
                                                    </Col>
                                                </Row>

                                                
                                    </Form> 
                                </Card.Body>                
                            </Card>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="secondary-outline" onClick={this.handleCloseModalCampo}>
                            Fechar
                        </Button>
                        <Button variant="secondary" onClick={(e) => this.salvarCampo(e)}>
                            {this.state.loading ? <span className="spinner-border spinner-border-sm"></span> : (this.state.campo_personalizado_id) ? 'Editar Campo Personalizado Paciente ' + this.state.campo_personalizado_id : 'Cadastrar Campo Personalizado Paciente'}      
                        </Button>
                    </Modal.Footer>
                </Modal>

                {/* Modal de Ajuda das Máscaras */}
                <Modal 
                    show={this.state.showMascaraHelp} 
                    onHide={() => this.setState({showMascaraHelp: false})} 
                    size="lg"
                    centered
                >
                    <Modal.Header closeButton>
                        <Modal.Title>Diretivas de Máscara para Campos Personalizados</Modal.Title>
                    </Modal.Header>
                    <Modal.Body style={{maxHeight: '70vh', overflowY: 'auto'}}>
                        <Alert variant="info">
                            <strong>Como usar:</strong> As diretivas são separadas por <code>|</code> e podem ser combinadas livremente.
                        </Alert>
                        
                        <h5 className="mt-4">Posicionamento</h5>
                        <p>Posicione o campo em relação a outros campos (fixos ou personalizados):</p>
                        <ul>
                            <li>
                                <code>position-after=CAMPO</code> - Aparece após o campo especificado<br />
                                <small className="text-muted">Exemplo: <code>position-after=tipo_cuidador</code></small>
                            </li>
                            <li>
                                <code>position-before=CAMPO</code> - Aparece antes do campo especificado<br />
                                <small className="text-muted">Exemplo: <code>position-before=cuidador_nome</code></small>
                            </li>
                        </ul>
                        <Badge bg="secondary">Campos fixos: tipo_cuidador, cuidador_nome, cuidador_cpf, etc.</Badge>{' '}
                        <Badge bg="info">Campos personalizados: use o slug do campo</Badge>
                        
                        <h5 className="mt-4">Visibilidade Condicional</h5>
                        <p>Mostre o campo apenas quando uma condição for atendida:</p>
                        
                        <h6>Uma Condição</h6>
                        <ul>
                            <li>
                                <code>show-on[campo_paciente=CAMPO|campo_valor=VALOR]</code><br />
                                <small className="text-muted">Exemplo: <code>show-on[campo_paciente=tipo_cuidador|campo_valor=outro]</code></small>
                            </li>
                            <li>
                                <code>show-on[campo_extra=SLUG|campo_valor=VALOR]</code> - Para campos personalizados<br />
                                <small className="text-muted">Exemplo: <code>show-on[campo_extra=possui-condicao|campo_valor=sim]</code></small>
                            </li>
                        </ul>
                        
                        <h6>Múltiplas Condições (AND)</h6>
                        <Alert variant="success">
                            Combine múltiplas condições - TODAS precisam ser verdadeiras!
                        </Alert>
                        <p>Use múltiplos blocos <code>show-on[...]</code> separados por <code>|</code>:</p>
                        <div className="bg-light p-3 rounded mb-2">
                            <code>show-on[CONDIÇÃO1]|show-on[CONDIÇÃO2]|show-on[CONDIÇÃO3]</code>
                        </div>
                        <p><strong>Exemplo real:</strong> Campo aparece SOMENTE se paciente tem cuidador E campo personalizado está marcado:</p>
                        <div className="bg-light p-3 rounded mb-3">
                            <code>show-on[campo_paciente=vinculo_cuidador|campo_valor=true]|show-on[campo_extra=paciente-tem-cuidador|campo_valor=Sim]</code>
                        </div>
                        <ul className="mb-0">
                            <li>✅ Condição 1: <code>vinculo_cuidador = true</code> (campo fixo do paciente)</li>
                            <li>✅ Condição 2: <code>paciente-tem-cuidador = Sim</code> (campo personalizado)</li>
                            <li>⚠️ <strong>Ambas</strong> precisam ser verdadeiras para mostrar o campo!</li>
                        </ul>
                        
                        <h5 className="mt-4">Contexto (Novo/Edição)</h5>
                        <p>Controle em qual momento o campo aparece:</p>
                        <ul>
                            <li>
                                <code>context=new</code> - Apenas ao cadastrar novo paciente<br />
                                <small className="text-muted">Exemplo: Campo &quot;Motivo do Cadastro&quot;</small>
                            </li>
                            <li>
                                <code>context=edit</code> - Apenas ao editar paciente existente<br />
                                <small className="text-muted">Exemplo: Campo &quot;Observações de Acompanhamento&quot;</small>
                            </li>
                            <li>
                                <code>context=both</code> - Em ambos os contextos (padrão)
                            </li>
                        </ul>
                        
                        <h5 className="mt-4">Validação de Comprimento</h5>
                        <ul>
                            <li><code>min-length=N</code> - Comprimento mínimo do texto</li>
                            <li><code>max-length=N</code> - Comprimento máximo do texto</li>
                        </ul>
                        
                        <h5 className="mt-4">Campo Informativo</h5>
                    <ul>
                        <li>
                            <code>information-field</code> - Renderiza como Alert informativo (em vez de input)<br />
                            <small className="text-muted">O conteúdo vem da Descrição do campo</small>
                        </li>
                    </ul>

                    <h5 className="mt-4">⚠️ Alerta de Preenchimento (Novidade)</h5>
                    <p>Exibe um alerta persistente na tela de <strong>Atendimento</strong> (topo das informações do paciente) enquanto este campo não for preenchido.</p>
                    <p><strong>Configuração:</strong> Utilize o **Gerador de Regras (No-Code)** no menu principal para configurar o tipo &quot;Alerta Dinâmico (Persistent)&quot;. </p>
                    <ul>
                        <li>
                            <small className="text-muted">Exemplo: <code>valor_campo=null.then(mensagemalerta=Confirmar melhor horário para contato)</code></small>
                        </li>
                    </ul>
                    <Alert variant="warning">
                        O alerta desaparecerá automaticamente assim que o campo receber qualquer valor.
                    </Alert>

                        <h5 className="mt-4">Cálculos Avançados (Novo)</h5>
                        <p>Permite comparar valores calculados (ex: idade):</p>
                        <ul>
                            <li>
                                <code>calc=age-gt-N</code> - Idade maior que N<br />
                                <small className="text-muted">Ex: <code>show-on[campo_paciente=data_nascimento|calc=age-gt-18]</code></small>
                            </li>
                            <li>
                                <code>calc=age-gte-N</code> - Idade maior ou igual a N
                            </li>
                            <li>
                                <code>calc=age-lt-N</code> - Idade menor que N
                            </li>
                            <li>
                                <code>calc=age-lte-N</code> - Idade menor ou igual a N
                            </li>
                            <li>
                                <code>calc=age-eq-N</code> - Idade igual a N
                            </li>
                        </ul>
                        
                        <h5 className="mt-4">Exemplos Práticos</h5>
                        
                        <div className="bg-light p-3 rounded mb-2">
                            <strong>Exemplo 1:</strong> Campo que aparece após tipo_cuidador somente quando &quot;outro&quot; é selecionado
                            <pre className="mb-0 mt-2"><code>show-on[campo_paciente=tipo_cuidador|campo_valor=outro]|position-after=tipo_cuidador</code></pre>
                        </div>
                        
                        <div className="bg-light p-3 rounded mb-2">
                            <strong>Exemplo 2:</strong> Campo apenas no cadastro, com validação de tamanho
                            <pre className="mb-0 mt-2"><code>context=new|min-length=10|max-length=200</code></pre>
                        </div>
                        
                        <div className="bg-light p-3 rounded mb-2">
                            <strong>Exemplo 3:</strong> Combinação completa
                            <pre className="mb-0 mt-2"><code>show-on[campo_paciente=tipo_cuidador|campo_valor=outro]|context=new|position-after=tipo_cuidador</code></pre>
                        </div>

                        <div className="bg-light p-3 rounded mb-2">
                            <strong>Exemplo 4:</strong> Mostrar apenas se maior de 18 anos
                            <pre className="mb-0 mt-2"><code>show-on[campo_paciente=data_nascimento|calc=age-gte-18]</code></pre>
                        </div>

                        <div className="bg-light p-3 rounded mb-2">
                            <strong>Exemplo 5:</strong> Alerta dinâmico se campo estiver vazio
                            <pre className="mb-0 mt-2"><code>valor_campo=null.then(mensagemalerta=Favor validar CPF do paciente)</code></pre>
                        </div>
                        
                        <div className="bg-light p-3 rounded mb-2">
                            <strong>Exemplo 6:</strong> Posicionar após outro campo personalizado
                            <pre className="mb-0 mt-2"><code>position-after=especifique-grau-parentesco</code></pre>
                            <small className="text-muted d-block mt-1">Use o slug do campo personalizado!</small>
                        </div>
                        
                        <Alert variant="warning" className="mt-4">
                            <strong>⚠️ Atenção:</strong> O <code>[]</code> fecha apenas na diretiva <code>show-on</code>. As outras diretivas não usam colchetes.
                        </Alert>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="secondary" onClick={() => this.setState({showMascaraHelp: false})}>
                            Fechar
                        </Button>
                    </Modal.Footer>
                </Modal>
            </div>
        );
    }
}

export default withRouter(CamposPersonalizados);
